import { render, staticRenderFns } from "./EditShareholderDetails.vue?vue&type=template&id=28f06926&"
import script from "./EditShareholderDetails.vue?vue&type=script&lang=js&"
export * from "./EditShareholderDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditShareholderDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports